export default __webpack_public_path__ + "static/media/MA.8dc5a34c.svg";